import React from 'react';
import { ColumnInstance, Row } from 'react-table';
import { NotificationRule } from '@sp-types/notificationRule';
import { SpotLockUser } from '@sp-types/userType';
import { Checkbox, MenuItem, Select } from '@mui/material';
import { Add, Delete } from '@mui/icons-material';

interface Props {
  row: Row<NotificationRule>;
  columns: ColumnInstance<NotificationRule>[];
  users: SpotLockUser[];
  updateRow: (_id: string, _patch: Partial<NotificationRule>) => void;
}

export const NotifExpandRow: React.FC<Props> = ({ row, columns, users, updateRow }) => {
  const [assignees, setAssignees] = React.useState<Record<string, any>>(row.original.assignees);

  React.useEffect(() => {
    if (row.original.assignees) {
      setAssignees(row.original.assignees || {});
    }
  }, [row.original.assignees]);

  return users.map(({ id, name }, ai: number) => (
    <tr key={ai} className="border-gray-125">
      {columns.map((col: any, ci: number) => (
        <td key={ci} className={`${ai >= users.length - 1 ? 'border-b' : ''} first:border-l last:border-r px-4 py-2`}>
          {col.id === 'assignee' && (
            <Select
              value={id}
              className="h-8 w-32"
              disabled
              onChange={({ target }) => {
                const userRec = {
                  [target.value]: {
                    ...assignees?.[target.value],
                    user: users.find((u) => u.id === target.value)?.name || '',
                  },
                };
                setAssignees((prev) => ({ ...prev, ...userRec }));
              }}
            >
              <MenuItem value={id}>{name}</MenuItem>
            </Select>
          )}
          {col.id === 'dashboard' && <Checkbox checked disabled onChange={() => {}} />}
          {col.type === 'boolean' && (
            <Checkbox
              checked={!!assignees?.[id]?.[col.id]}
              disabled={!id}
              onChange={({ target }) => {
                const fff = {
                  assignees: {
                    ...assignees,
                    [id]: { ...assignees?.[id], user: name, [col.id]: !!target.checked },
                  },
                };

                console.log('updateRow', row.original.id, fff);
                updateRow(row.original.id, fff);
              }}
            />
          )}
          {col.id === 'modifiedAt' && (
            <div>
              {/* <Add /> */}
              {/* <Delete /> */}
            </div>
          )}
        </td>
      ))}
    </tr>
  ));
};
